var CHAR_CODES;
(function (CHAR_CODES) {
    CHAR_CODES[CHAR_CODES["ENTER"] = 13] = "ENTER";
    CHAR_CODES[CHAR_CODES["SPACE"] = 32] = "SPACE";
})(CHAR_CODES || (CHAR_CODES = {}));
var handleKeyDown = function (keyCode, handler) { return function (event) {
    if (event.keyCode === keyCode) {
        event.preventDefault();
        handler();
    }
}; };
export var handleSpaceKeyDown = function (handler) { return function (event) { return handleKeyDown(CHAR_CODES.SPACE, handler)(event); }; };
export var handleKeyPressEnterOrSpace = function (handler) { return function (event) {
    if (event.key === ' ' || event.key === 'Enter') {
        handler(event);
    }
}; };
export var focusElement = function (_a) {
    var selector = _a.selector, _b = _a.canFocus, canFocus = _b === void 0 ? false : _b, _c = _a.preventScroll, preventScroll = _c === void 0 ? false : _c;
    var element = document.querySelector(selector);
    if (element) {
        !canFocus && element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll: preventScroll });
    }
};
export var scrollElementIntoView = function (selector, scrollOptions) {
    if (scrollOptions === void 0) { scrollOptions = {}; }
    document.querySelector(selector).scrollIntoView(scrollOptions);
};
export var addCircularTabFocus = function (firstElementSelector, lastElementSelector) {
    var first = document.querySelector(firstElementSelector);
    var last = document.querySelector(lastElementSelector);
    if (first && last) {
        first.addEventListener('keydown', function (event) {
            if (event.keyCode === 9 && event.shiftKey) {
                event.preventDefault();
                last.focus();
            }
        });
        last.addEventListener('keydown', function (event) {
            if (event.keyCode === 9 && !event.shiftKey) {
                event.preventDefault();
                first.focus();
            }
        });
    }
};
//# sourceMappingURL=helpers.js.map